import { CircleAlert } from "lucide-react";

export const CenteredErrorIcon = () => {
    return (
        <div className="absolute inset-0 flex items-center justify-center">
            <CircleAlert className="m-4 size-10" />
        </div>
    );
};
